const formatCurrency = (value: string | number | undefined): string => {
	if (!value && value !== 0) return ''

	const numberValue =
		typeof value === 'string'
			? parseFloat(value.replace(/[^\d.-]/g, ''))
			: value

	if (isNaN(numberValue)) return ''

	return new Intl.NumberFormat('es-CO', {
		style: 'currency',
		currency: 'COP',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(numberValue)
}

export default formatCurrency
